import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { APPROVAL_EDIT_PANEL_OPENED } from '../../constants/trackingConstants';
import withErrorBoundary from '../../hoc/withErrorBoundary';
import useApprovalConditions from '../../hooks/useApprovalConditions';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { trackInteraction } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const ApprovalReassignButton = () => {
  const approval = useApprovalContext();
  const {
    canEditApproval
  } = useApprovalConditions();
  if (!canEditApproval) {
    return null;
  }
  const openApprovalEditPanel = () => {
    approval.meta.setShowApprovalEditPanel(true);
    trackInteraction(APPROVAL_EDIT_PANEL_OPENED, approval.meta.approvalType);
  };
  return /*#__PURE__*/_jsx(Link, {
    onClick: openApprovalEditPanel,
    "data-test-id": "reassign-approval-button",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.reassignApprovers"
    })
  });
};
export default withErrorBoundary(ApprovalReassignButton);